import * as actionType from '../actions/actionTypes';
import { updateObject } from '../../components/shared/utility';

const initialState = {
    stepIndex: 0,
    stepperLength: 0,
    finished: false,
    linkedQuestionForCategory: [],
};

const initialiseStepper = (state, action) => {
    return updateObject(state, {
        finished: false,
        stepIndex: 0,
        stepperLength: action.stepperLength
    })
};

const onStepperNext = (state, action) => {
    return updateObject(state, {
        stepIndex: action.stepIndex + 1,
        finished: action.stepIndex === state.stepperLength
    })
};

const onStepperPrev = (state, action) => {
    return updateObject(state, {
        stepIndex: action.stepIndex - 1,
        finished: action.stepIndex === state.stepperLength
    })
};

const onStepperActive = (state, action) => {
    return updateObject(state, {
        stepIndex: action.stepIndex,
        finished: action.stepIndex === state.stepperLength
    })
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.STEPPER_INIT:
            return initialiseStepper(state, action);
        case actionType.STEPPER_NEXT:
            return onStepperNext(state, action);
        case actionType.STEPPER_PREV:
            return onStepperPrev(state, action);
        case actionType.STEPPER_ACTIVE:
            return onStepperActive(state, action);
        default:
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/stepperReducer.js